import React from 'react';
import agent from '../../../../agent';
import TextWidget from '../TextWidget/TextWidget'
import LoaderWidget from '../Loader/LoaderWidget'
import {checkForUnauthorisedResponse} from '../../../Utils/ErrorHandler'


class SavedSearchCountWidgetContainer extends React.Component {

  constructor() {
    super();
    this.state = {
      search: {
        value:0
      },
      loaded:false
    };
  }

  componentDidMount() {
    this.refresh();
  }

  refresh() {
    this.runSearch(this.props.savedSearchId, "count", this.props.bypassCache);
  }

  runSearch(savedSearchId, searchResultType, bypassCache) {
    agent.Search.executeSearch(savedSearchId, searchResultType, bypassCache).then(
      res => {
        if(res.result) {
          this.setState({
            ...this.state,
            search:res.data,
            loaded:true
          })
        } else {
          this.setState({
            ...this.state,
            loaded:true
          })
        }
      },
      error => {
        if(!checkForUnauthorisedResponse(error, agent)) {
          this.setState({
            ...this.state,
            'loaded':true
          })
        }
      }
    )
  }

  render() {
    if(this.state.loaded) {
      return (
        <TextWidget {...this.props} onWidgetRefresh={this.refresh.bind(this)} value={this.state.search.value}/>
      )
    } else {
      return (
        <LoaderWidget {...this.props}/>
      )
    }
  }
}

export default SavedSearchCountWidgetContainer;



// WEBPACK FOOTER //
// ./src/components/Dashboard/components/SavedSearchCountWidget/SavedSearchCountWidgetContainer.js